export const opticians = ["Optician", "OpticianDispeningOnly"];
export const endUsers = ["CustomerOfDistributor", "CustomerOfDistributorEyeTicketOnly", "DirectUser", "DirectUserEyeTicketOnly"];
export const distributors = ["Distributor"];